const { default: axios } = require("axios");
import Swal from 'sweetalert2';
import $ from 'jquery';
import moment from 'moment';

document.querySelector('#privateRequests') && new Vue({
    el: '#privateRequests',
    data: function () {
        return {
            date_of_request: null,
            make: null,
            model: null,
            plate_no: null,
            km_l: null,
            vehicle_id: null,
            no_of_liters: null,
            driver_id: null,
            passengers: [{
                first_name: null,
                middle_name: null,
                last_name: null,
            }],
            fuelTypes,
            destination: null,
            purpose: null,
            fuel_id: null,
            gas_slip: null,
            excess_in_container: null,
        };
    },
    methods: {
        vehicleChange() {
            if (this.vehicle_id === 'new') {
                this.make = null;
                this.model = null;
                this.plate_no = null;
                return;
            }

            if (!this.vehicle_id) {
                return;
            }

            const vehicle = this.selectedVehicle;
            this.make = vehicle?.make || null;
            this.model = vehicle?.model || null;
            this.plate_no = vehicle?.plate_no || null;

            console.log(this.selectedVehicle, this.selectedVehicleIsForOnePerson)
            if (this.selectedVehicleIsForOnePerson) {
                this.passengers = [];
                if (this.selectedDriver != null) {
                    this.passengers.push({
                        first_name: this.selectedDriver.first_name,
                        middle_name: this.selectedDriver.middle_name,
                        last_name: this.selectedDriver.last_name,
                    })
                    this.$forceUpdate();
                }
                else {
                    this.addPassenger();
                }
            }
        },
        addPassenger() {
            this.passengers = [
                ...this.passengers, {
                    first_name: null,
                    middle_name: null,
                    last_name: null,
                }
            ]
        },
        deletePassenger(index) {
            var arr = this.passengers;

            arr.splice(index, 1);

            this.passengers = arr;
        },
        confirm() {
            try {
                if (this.vehicle_id == null || this.vehicle_id === '') {
                    throw 'Vehicle is required';
                }

                if (this.isNewVehicle && this.make == null) {
                    throw 'Make is required';
                }

                if (this.isNewVehicle && this.model == null) {
                    throw 'Model is required';
                }

                if (this.date_of_request == null) {
                    throw 'Date of request is required';
                }

                if (this.no_of_liters == null) {
                    throw 'No. of liters is required';
                }


                if (this.driver_id == null) {
                    throw 'Driver is required';
                }

                if (this.destination == null) {
                    throw 'Destination is required';
                }

                if (this.purpose == null) {
                    throw 'Purpose is required';
                }

                if (this.fuel_id == null) {
                    throw 'Fuel is required';
                }


                $('#confirmationModal').modal('show');
            } catch (e) {
                new Swal('Error!', e, 'error'); 4
            }

        },
        async submit() {
            try {
                const res = await axios.post('/pgo/private-requests', {
                    make: this.make,
                    model: this.model,
                    plate_no: this.plate_no,
                    fuel_id: this.fuel_id,
                    km_l: this.km_l,
                    date_of_request: this.date_of_request,
                    vehicle_id: this.isNewVehicle ? null : this.vehicle_id,
                    no_of_liters: this.no_of_liters,
                    driver_id: this.driver_id,
                    passengers: this.selectedPassengers,
                    destination: this.destination,
                    purpose: this.purpose,
                    fuel_id: this.fuel_id,
                    excess_in_container: this.excess_in_container,
                })

                this.gas_slip = `/office/gas-slip-request/${res.data['id']}/print`

                this.make = null;
                this.model = null;
                this.km_l = null;
                this.fuel_id = null;
                this.date_of_request = null;
                this.vehicle_id = null;
                this.no_of_liters = null;
                this.driver_id = null;
                this.passengers = [{
                    first_name: null,
                    middle_name: null,
                    last_name: null,
                }];
                this.destination = null;
                this.purpose = null;
                this.fuel_id = null;

                $('#confirmationModal').modal('hide');
                // $('#gasSlipModal').modal('show');
                new Swal('Success!', 'Gas slip request submitted successfully', 'success');

            } catch (e) {
                new Swal('Error', e, 'error');
            }
        },
        print() {
            var prtContent = document.getElementById("gasSlipImg");
            var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            WinPrint.document.write(prtContent.innerHTML);
            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.print();
        }
    },
    computed: {
        selectedVehicleIsForOnePerson() {
            return false;

            if (this.selectedVehicle != null && (
                this.selectedVehicle.type == "Heavy Equipment" ||
                this.selectedVehicle.type == "Generator" ||
                this.selectedVehicle.type == "Other"
            )) {
                return true;
            }

            return false;
        },
        selectedVehicle() {
            if (this.vehicle_id == null || this.vehicle_id === 'new') {
                return null;
            }

            return vehicles.find((e) => e.id == this.vehicle_id);
        },

        isNewVehicle() {
            return this.vehicle_id === 'new';
        },

        selectedDriver() {
            if (this.driver_id == null) {
                return null;
            }

            return drivers.find((e) => e.id == this.driver_id);
        },
        selectedPassengers() {
            return this.passengers.filter((e) => e.first_name != null || e.last_name != null || e.middle_name != null);
        },
        selectedFuelType() {

            if (!fuelTypes) {
                return;
            }

            if (this.fuel_id == null) {
                return null;
            }

            return fuelTypes.find((e) => e.id == this.fuel_id);
        },
        filteredFuels() {
            if (!fuelTypes) return;

            const fuelType = this.fuel_type;

            return fuelTypes.filter((e) => e.fuel_type == fuelType);
        }
    },
    mounted() {
        this.date_of_request = moment().format('YYYY-MM-DD');

        $('#private_vehicle_select').select2({
            width: '100%',
        });

        $('#private_vehicle_select').on('change', (event) => {
            this.vehicle_id = $(event.target).val();
            this.vehicleChange();
        });

        console.log(this.date_of_request);
    }
})
